/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { textPostTextAesEncrypt } from "../../funcs/textPostTextAesEncrypt.js";
import { PostTextAesEncryptRequest$zodSchema } from "../../models/posttextaesencryptop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostTextAesEncryptRequest$zodSchema,
};

export const tool$textPostTextAesEncrypt: ToolDefinition<typeof args> = {
  name: "text-post-text-aes-encrypt",
  description: `AES 加密

需要安全地传输或存储一些文本信息？AES加密是一个可靠的选择。

## 功能概述
这是一个标准的AES加密接口。你提供需要加密的明文和密钥，我们返回经过Base64编码的密文。

> [!IMPORTANT]
> **关于密钥 \`key\`**
> 我们支持 AES-128, AES-192, 和 AES-256。请确保你提供的密钥 \`key\` 的长度（字节数）正好是 **16**、**24** 或 **32**，以分别对应这三种加密强度。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await textPostTextAesEncrypt(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
